export default __webpack_public_path__ + "static/media/bio1.a4ee4129.jpg";